import React from "react";

function RentCollection() {
  return (
    <>
      <main>Rent Collection tab</main>
    </>
  );
}

export default RentCollection;
